import { createSignal } from 'solid-js'

export const focusFirstInvalid = (root?: HTMLElement) => {
  const scope =
    root ?? document.activeElement?.closest('[data-form-scope], [role="dialog"], form') ?? document
  const visible = (selector: string) =>
    [...scope.querySelectorAll<HTMLElement>(selector)].filter(
      (element) => element.getClientRects().length > 0,
    )
  const marked = visible('[aria-invalid="true"], [data-field-error="true"]')
  const alerts = visible('[role="alert"]')
  const errors = marked.length ? marked : alerts.length ? alerts : visible('.text-status-critical')
  for (const error of errors) {
    if (!error.getClientRects().length) continue
    let field: HTMLElement | null = error
    while (field) {
      const control = field.matches('input, select, textarea, button, [tabindex]')
        ? field
        : field.querySelector<HTMLElement>(
            'input:not([type="hidden"]):not([type="file"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])',
          )
      if (control?.getClientRects().length) {
        control.focus()
        control.scrollIntoView({ block: 'nearest' })
        return
      }
      if (field === scope) break
      field = field.parentElement
    }
  }
}

export const createFormErrors = () => {
  const [submitted, setSubmitted] = createSignal(false)
  const [touched, setTouched] = createSignal<ReadonlySet<string>>(new Set())
  return {
    submitted,
    show: (key: string) => submitted() || touched().has(key),
    touch: (key: string) => setTouched((keys) => new Set([...keys, key])),
    submit: (valid: boolean, root?: HTMLElement) => {
      setSubmitted(true)
      if (!valid) {
        const scope =
          root ??
          document.activeElement?.closest<HTMLElement>('[data-form-scope], [role="dialog"], form')
        requestAnimationFrame(() => focusFirstInvalid(scope ?? undefined))
      }
      return valid
    },
    reset: () => {
      setSubmitted(false)
      setTouched(new Set<string>())
    },
  }
}
